import * as SmallCustomIcon from './SmallCustomIcon';
import * as MediumCustomIcon from './MediumCustomIcon';
import * as LargeCustomIcon from './LargeCustomIcon';


export const CustomIcons = {
  LargeIcon: LargeCustomIcon,
  MediumIcon: MediumCustomIcon,
  SmallCustomIcon: SmallCustomIcon
};

export type LargeIconType = LargeCustomIcon.IconTypes;
export type MediumIconType = MediumCustomIcon.IconTypes;
export type SmallIconType = SmallCustomIcon.IconTypes;
